import React, { Component } from 'react';

import { messages } from '@qality/common-messages';

import './_test-execution-history-list.scss';

export default class TestExecutionNotFoundHistoryList extends Component {
  render(): React.ReactNode {
    return (
      <div className='execution-history-info-wrapper'>
        <h2 className='execution-history-info-header'>
          {messages['info.testExecutionHistoryPage.page.not.found.message']}
        </h2>
      </div>
    );
  }
}
